import React, { useState,useEffect } from 'react';
import { Menu} from 'antd';
import './AppHeader.scss';
import { useLocation } from 'react-router-dom';
import { useNavigate  } from 'react-router-dom';
import { useLanguageContext } from 'components/languageWrapper/LanguageWrapper';
import { TranslateString } from 'Utils/Common';
import UserService from 'services/UserService';

function HeaderMenus(props:any) {
    const [menus, setMenus] = useState<any>([]);
    const location:any = useLocation();
    const [current, setCurrent] = useState('import');
   
    let navigate = useNavigate();
    const { selectLanguage } = useLanguageContext();
    // const { getSelectLanguage } = useLanguageContext();
    // const selectedLanguage:any = getSelectLanguage();  

    useEffect(()=>{
        if(props?.menus){
            setMenus(props?.menus);
        }
    },[props?.menus])

    useEffect(()=>{
        if(menus.length>0){
            setMenus(menus);
            
            if(location?.pathname.includes("/housingcompaies-analysis")){
                setCurrent('housingcompany');
            }else{
                setCurrent(location?.pathname.replace("/",""));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[menus])

    const onClick: any = (e:any) => {
        if(e?.type==='select'){
            let tempMenus:any = menus;
            let index = tempMenus.findIndex((f:any)=>f.key===e?.key);
            tempMenus[index]['value'] = e.value;
            localStorage.setItem("language",e.value)
            setMenus(tempMenus);
            selectLanguage(e.value);
        }else if(e.value==="logout"){
            UserService.doLogout()
        }else{
            setCurrent(e.value);
            navigate('/'+e.value);
        }
    };

    return (
        <Menu mode="horizontal" selectedKeys={[current]} className="cu-bg-none text-white fs-6 font-weight-bold cu-header-menus">
            { 
                menus?.map((element:any)=>{
                    if(element?.items){
                        let selectedTitle:any = element.label;
                        if(element?.type==="select"){
                            selectedTitle = element?.items?.find((f:any)=>f.key===element['value'])?.label || selectedTitle;
                        }else{
                            selectedTitle = element?.label;
                        }
                        if(element?.key!=='user'){
                            selectedTitle = TranslateString(selectedTitle);
                        }
                        if(selectedTitle === 'housing_manager'){
                            selectedTitle = TranslateString(selectedTitle);
                        }
                        return (
                            <Menu.SubMenu 
                                key={element.key} 
                                title={selectedTitle} 
                                icon={element.icon}
                            >
                                {
                                    (()=>{
                                        return element?.items?.map((subMenu:any)=>{
                                            let obj:any = {};
                                            obj.type = element?.type;
                                            obj.key = element?.key;
                                            obj.value = subMenu?.key;
                                            obj.icon = subMenu.icon;
                                            return (
                                                <Menu.Item key={subMenu?.key} icon={subMenu.icon} onClick={(e:any)=>{e={e,...obj};onClick(e)}}>
                                                    {TranslateString(subMenu?.label)}
                                                </Menu.Item>
                                            )
                                        })
                                    })()
                                }
                            </Menu.SubMenu>
                        );
                    }else{
                        let obj:any = {};
                        obj.type = 'item';
                        obj.key = element?.key;
                        obj.value = element?.key;
                        return (
                            <Menu.Item key={element?.key} icon={element?.icon} onClick={(e:any)=>{e={e,...obj};onClick(e)}}>
                                {TranslateString(element?.label)}
                            </Menu.Item>
                        );
                    }
                })
            }
        </Menu>
    );
}

export default HeaderMenus;